import React, { forwardRef } from "react";
import { FieldTypes, urlRegexValidator } from "utils/formUtils";

import GenericPullCredentialsForm from "../GenericPullCredentialsForm";
import CybeatsMappingForm from "./CybeatsMappingForm";

const CybeatsCredentialsForm = (props, ref) => {
  const fields = [
    {
      name: "apiEndpoint",
      label: "API Endpoint",
      rules: [urlRegexValidator],
      required: true,
    },
    {
      name: "accessKey",
      label: "Access Key",
      type: FieldTypes.PASSWORD,
      required: true,
    },
    {
      name: "secretKey",
      label: "Secret Key",
      type: FieldTypes.PASSWORD,
      required: true,
    },
  ];

  return (
    <GenericPullCredentialsForm
      {...props}
      ref={ref}
      fields={fields}
      MappingForm={CybeatsMappingForm}
      initialValue={{ apiEndpoint: "https://api.us.services.cybeats.com/v1" }}
    />
  );
};

export default forwardRef(CybeatsCredentialsForm);